import { createStore } from 'zustand'

import { checksActions, checksLoaders, checksMutations } from './checks'
import {
  directoryAccountsActions,
  directoryAccountsLoaders,
} from './directoryAccounts'
import { editsActions, editsLoaders, editsMutations } from './edits'
import { projectActions, projectLoaders, projectMutations } from './project'
import {
  statementsActions,
  statementsLoaders,
  statementsMutations,
} from './statements'
import {
  transactionsActions,
  transactionsLoaders,
  transactionsMutations,
} from './transactions'
import type { ProjectStore } from './types'

export type { ProjectStore }

export const createProjectStore = () =>
  createStore<ProjectStore>((set, get, store) => ({
    loadingProject: true,
    loadingStatements: true,
    loadingTransactions: true,
    loadingChecks: true,
    loadingMoreTransactions: false,
    loadingMoreChecks: false,
    transactionsLoadId: 0,
    checksLoadId: 0,
    loadingDirectoryAccounts: true,
    mutating: false,
    project: null,
    statements: [],
    transactions: [],
    checks: [],
    directoryAccounts: [],
    edits: [],
    filterByFavorites: false,

    actions: {
      ...projectActions(set, get, store),
      ...statementsActions(set, get, store),
      ...transactionsActions(set, get, store),
      ...checksActions(set, get, store),
      ...directoryAccountsActions(set, get, store),
      ...editsActions(set, get, store),
    },

    mutations: {
      ...projectMutations(set, get, store),
      ...statementsMutations(set, get, store),
      ...transactionsMutations(set, get, store),
      ...checksMutations(set, get, store),
      ...editsMutations(set, get, store),
    },

    loaders: {
      ...projectLoaders(set, get, store),
      ...statementsLoaders(set, get, store),
      ...transactionsLoaders(set, get, store),
      ...checksLoaders(set, get, store),
      ...directoryAccountsLoaders(set, get, store),
      ...editsLoaders(set, get, store),
    },
  }))
